import getLocale from "@/utils/get-locale";

export default {
  computed: {
    $_locale() {
      return getLocale();
    }
  }
};
